// Keyed by platformAgentName: `amigo` on FoodAmigos, `assistant` on a partner's dashboard.
export default {
  name: {
    amigo: 'Amigo',
    assistant: 'Assistente',
  },
  close: {
    amigo: 'Chiudi Amigo',
    assistant: "Chiudi l'assistente",
  },
  brand: 'Brand',
  // No restaurant selected in the dashboard (D18): the header's line.
  no_restaurant: 'Nessun ristorante selezionato',
  // The header (D4): Chats opens the restaurant's chats in the panel, New chat starts an empty one.
  chats: 'Chat',
  new_chat: 'Nuova chat',
  back: 'Torna alla chat',
  // Other chats with answers the person hasn't read (QA45): the line under the header leads to Chats.
  news_elsewhere_one: "Nuove risposte in un'altra chat",
  news_elsewhere_other: 'Nuove risposte in altre {{count}} chat',
};
